import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitFour = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-4%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 1.14 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 1.14 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1023"
      height="444"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitFour"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M1019.82 358.075c-6.39 23.85-26.609 42.862-57.867 56.778-31.254 13.915-73.47 22.698-123.692 26.127-100.438 6.858-232.785-7.708-373.223-45.338-140.439-37.631-262.337-91.19-345.891-147.348-41.78-28.081-73.947-56.795-94.056-84.472C4.978 136.141-3.027 109.566 3.364 85.716c6.39-23.85 26.61-42.863 57.869-56.78C92.487 15.024 134.702 6.24 184.924 2.81c100.439-6.858 232.786 7.708 373.224 45.338s262.337 91.19 345.891 147.348c41.779 28.081 73.946 56.795 94.056 84.472 20.115 27.681 28.115 54.256 21.725 78.107Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="925.99"
          x2="181.97"
          y1="25.479"
          y2="391.321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-4@2x.png`}
        width="50"
        height="50"
        x={isDesktop ? 25 : 290}
        y={isDesktop ? 10 : 315}
      >
        <mpath href="#orbitFour" />
      </image>
    </motion.svg>
  );
};

export default OrbitFour;
